// Shared post-create sequence for a freshly minted workspace. A just-created
// workspace isn't in `setWorkspace`'s cached list yet, so this refetches both
// the workspaces list and the identity (org grants / the selector's
// workspace list both live on it) before navigating there directly, rather
// than routing through `setWorkspace`. Used by both create-workspace entry
// points — the picker and the landing page.

import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { workspaceKeys } from "@/api/keys";
import { persistId } from "./workspace-storage";

export function useOpenCreatedWorkspace() {
    const queryClient = useQueryClient();
    const navigate = useNavigate();

    return useCallback(
        async (id: string) => {
            await queryClient.refetchQueries({ queryKey: workspaceKeys.all });
            await queryClient.refetchQueries({ queryKey: ["me"] });
            persistId(id);
            void navigate({ to: "/w/$workspaceId", params: { workspaceId: id } });
        },
        [queryClient, navigate],
    );
}
